import { Box, Button, Text } from '@chakra-ui/react';
import React from 'react';

import AddressEntity from 'ui/shared/entities/address/AddressEntity';

import UserWalletAutoConnectAlert from '../UserWalletAutoConnectAlert';

interface Props {
  address: string;
  domain?: string;
  isAutoConnectDisabled?: boolean;
  isReconnecting?: boolean;
  onDisconnect: () => void;
}

const UserWalletMenuContent = ({ isAutoConnectDisabled, address, domain, onDisconnect }: Props) => {

  return (
    <Box>
      { isAutoConnectDisabled && <UserWalletAutoConnectAlert/> }
      <Text fontSize="sm" fontWeight={ 600 } mb={ 1 }>My wallet</Text>
      <Text fontSize="sm" mb={ 5 } fontWeight={ 400 } color="text_secondary">
        Your wallet is used to interact with apps and contracts in the explorer.
      </Text>
      <AddressEntity
        address={{ hash: address, ens_domain_name: domain }}
        isTooltipDisabled
        truncation="dynamic"
        fontSize="sm"
        fontWeight={ 700 }
      />
      <Button size="sm" width="full" variant="outline" onClick={ onDisconnect } mt={ 6 }>
        Disconnect
      </Button>
    </Box>
  );
};

export default React.memo(UserWalletMenuContent);
